import { HIGHLIGHTS, HIGHLIGHTS_EXCLUSIVE } from "../constants";

import type { JSX } from "react";

type TagProps = {
  text: string;
  flag: string;
  color: string;
  bgColor: string;
  icon: string | JSX.Element;
};

const getField = (flag: string, isFlagExclusive?: boolean) => {
  const flagFormatted = flag.toLowerCase().replace(/ /g, "-");
  const tag = isFlagExclusive
    ? HIGHLIGHTS_EXCLUSIVE.find((item) => item.id === flagFormatted)
    : HIGHLIGHTS.find((item) => item.id === flagFormatted);

  if (tag) {
    return tag;
  }
};

export const formatProductTags = (
  clusterHighlights: { id: string; name: string }[],
  isFlagExclusive?: boolean
): TagProps[] => {
  const tags = clusterHighlights.map((highlight) => {
    const tag = getField(highlight.name, isFlagExclusive);

    if (tag) {
      return {
        text: tag.label,
        flag: `flag-${tag.id}`,
        color: tag.color,
        bgColor: tag.bgColor,
        icon: tag?.icon
      };
    }
  });

  return tags.filter((tag): tag is TagProps => tag !== undefined);
};
